import {
  NO_ARGS,
  SINGLE_NUMERIC,
  SINGLE_STRING,
  twoNumeric,
} from './_argShapes';
import { STUB_NOT_IMPLEMENTED } from './_stubs';
import type { EffectEntry } from './types';

export const scale: EffectEntry = {
  kind: 'scale',
  category: 'effect',
  family: 'tonal',
  doc: 'fit notes to a scale: "C minor", "A dorian"',
  args: SINGLE_STRING,
  toCode: () => STUB_NOT_IMPLEMENTED('scale', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('scale', 'fromAst'),
};

export const chord: EffectEntry = {
  kind: 'chord',
  category: 'effect',
  family: 'tonal',
  doc: 'play a named chord: "Cmaj7", "Dm9"',
  args: SINGLE_STRING,
  toCode: () => STUB_NOT_IMPLEMENTED('chord', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('chord', 'fromAst'),
};

export const voicing: EffectEntry = {
  kind: 'voicing',
  category: 'effect',
  family: 'tonal',
  doc: 'spread chord voicing over octaves (no arg)',
  args: NO_ARGS,
  toCode: () => STUB_NOT_IMPLEMENTED('voicing', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('voicing', 'fromAst'),
};

export const arp: EffectEntry = {
  kind: 'arp',
  category: 'effect',
  family: 'tonal',
  doc: 'arpeggiate chords: "up", "down", "updown", "converge"',
  args: SINGLE_STRING,
  toCode: () => STUB_NOT_IMPLEMENTED('arp', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('arp', 'fromAst'),
};

export const transpose: EffectEntry = {
  kind: 'transpose',
  category: 'effect',
  family: 'tonal',
  doc: 'transpose by N semitones',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('transpose', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('transpose', 'fromAst'),
};

export const strans: EffectEntry = {
  kind: 'strans',
  category: 'effect',
  family: 'tonal',
  doc: 'transpose within the current scale by N steps',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('strans', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('strans', 'fromAst'),
};

export const bjork: EffectEntry = {
  kind: 'bjork',
  category: 'effect',
  family: 'tonal',
  doc: 'bjorklund euclidean rhythm: bjork(pulses, steps)',
  args: twoNumeric(
    { name: 'pulses', doc: 'number of pulses to distribute' },
    { name: 'steps', doc: 'total step count' },
  ),
  toCode: () => STUB_NOT_IMPLEMENTED('bjork', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('bjork', 'fromAst'),
};

export const add: EffectEntry = {
  kind: 'add',
  category: 'effect',
  family: 'tonal',
  doc: 'add constant to note numbers / numeric pattern',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('add', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('add', 'fromAst'),
};

export const sub: EffectEntry = {
  kind: 'sub',
  category: 'effect',
  family: 'tonal',
  doc: 'subtract constant',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('sub', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('sub', 'fromAst'),
};

export const mul: EffectEntry = {
  kind: 'mul',
  category: 'effect',
  family: 'tonal',
  doc: 'multiply constant',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('mul', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('mul', 'fromAst'),
};
